import React from "react";
import { useIntl } from "react-intl";

import { checkRequired } from "@components/Forms/Rules";
import { Field, Select } from "@components/Profile/Forms/HooksForm";

export default function LoyaltyCardForm({
  setFormVals,
  formVals,
  index,
  errors,
  setErrors,
  allLoyaltyPrograms,
}) {
  const intl = useIntl();

  const setValueInForm = (newVal, key) => {
    setFormVals(() => ({
      ...formVals,
      loyalties: formVals.loyalties.map((pp, idx) =>
        idx === index ? { ...pp, [key]: newVal } : pp
      ),
    }));
  };

  if (!allLoyaltyPrograms) return null;

  return (
    <>
      <Field
        required
        name="Id"
        id="Id"
        component={Select}
        options={allLoyaltyPrograms}
        label={intl.formatMessage({ id: "Form.loyaltyProgram" })}
        placeholder={intl.formatMessage({
          id: "Profile.loyaltyProgramPlaceholder",
        })}
        value={formVals?.loyalties[index].Id}
        error={errors.Id}
        setter={(newVal) => {
          const err = checkRequired(newVal);
          setErrors((state) => ({ ...state, Id: err }));
          setValueInForm(newVal, "Id");
        }}
      />
      <Field
        required
        name="MembershipId"
        id="MembershipId"
        label={intl.formatMessage({ id: "Profile.loyaltyId" })}
        placeholder={intl.formatMessage({
          id: "Profile.loyaltyIdPlaceholder",
        })}
        value={formVals?.loyalties[index].MembershipId}
        error={errors.MembershipId}
        setter={(newVal) => {
          const err = checkRequired(newVal);
          setErrors((state) => ({ ...state, MembershipId: err }));
          setValueInForm(newVal, "MembershipId");
        }}
      />
    </>
  );
}
